export const homeApiUrls = {
  featureAnnouncements: '/feature-announcements',
  getStoreSettings: '/account/settings/store/recommended-steps',
  getStoreOnboardingStatus: '/account/settings/store/onboarding-status',
  deactivateRecommendedSteps: '/account/settings/store/deactivate-recommended-steps',
  deactivateOnboardingSteps: '/account/settings/store/deactivate-onboarding-steps',
  getStoreOnboardingRules: '/api/v1/account/settings/store/get-store-onboarding-rules',
  getStoreRewards: '/api/v1/account/store/rewards',
};
